import React, { useRef, useState } from "react";
import "../style/projectOne.css";
import Skills from "./skills";
import { useInView } from "react-intersection-observer";
import {ImagesComp} from "./imags";


export default function ProjectOne(props) {
 
 
 

  const { ref, inView, entry } = useInView({
    threshold: 0.9,
    triggerOnce: true,
  });

  return (
    <div ref={ref} inView={inView}>
      {inView && (
        <div className="project_one_container">
          <div className="project_one_info">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 686 688">
              <g id="blockdesign">
                <rect
                  id="Rectangle_10"
                  data-name="Rectangle 10"
                  width="130"
                  height="130"
                  rx="86"
                  fill="rgb(225, 173, 1,0.2)"
                />
              </g>
            </svg>
            <h3 className="project_one_sub_header">
              My Last Project
              <span className="project_one_header">Maayan's Kitchen</span>
            </h3>

            <h3 className="project_one_sub_info">
              This website is an online menu for home-cooked meals.
              <br />
              the client wanted a website that her customers could see
              <br /> the menus and call with the orders.
              <br />
              she also wanted an admin section to update and changes
              <br /> the menu's (price, new dishes.....).
              <br />
              front end:react(router,hooks),CSS.
              <br />
              database: Mongo DB.
              <br />
              Aute:joi,bcreapt.
              <br />
              back end:nod js(express).
              <br />
            </h3>
          </div>
          <div className="project_one_img_box">
            <a target="blank" href="https://maayanskitchen.netlify.app">
            <img className="imgCell" src="images/maayan_kitchen.png"/>
              <ImagesComp imgSrc={"images/maayan_kitchen.png"}/> 
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
